import { combineReducers } from 'redux';
import session from './session';
import vehicleAd from './vehicleAd';
import vehicleMake from './vehicleMake';
import vehicleModel from './vehicleModel';
import vehicleGeneration from './vehicleGeneration';
import vehicleUtil from './vehicleUtil';
import vehicleFeature from './vehicleFeature';
import color from './color';
import vehicleBodyType from './vehicleBodyType';
import vehicleEngineType from './vehicleEngineType';
import user from './user';
import metaData from './metaData';
import bank from './bank';
import bankForm from './bankForm';
import bankUser from './bankUser';
import activeTabKey from './activeTabKey';
import city from './city';
import packages from './package';
import service from './service';
import sliderImage from './sliderImage';
import counts from './counts';
import userStats from './userStats';
import vehicleStats from './vehicleStats';
import blogsStats from './blogsStats';
import suggestion from './suggestion';
import orders from './order';
import vehicleUploads from './vehicleUploads';
import leads from './leads';
import inspectionOrders from './inspectionOrders';
import calender from './calender';
import banner from './banner';
import tags from './tags';
import userLevels from './userLevels';
import signupStats from './signupStats';

export const rootReducer = combineReducers({
	session,
	vehicleMake,
	vehicleModel,
	vehicleGeneration,
	user,
	vehicleAd,
	metaData,
	vehicleUtil,
	vehicleFeature,
	color,
	vehicleBodyType,
	vehicleEngineType,
	bankForm,
	bankUser,
	activeTabKey,
	city,
	bank,
	sliderImage,
	banner,
	packages,
	service,
	counts,
	userStats,
	vehicleStats,
	blogsStats,
	suggestion,
	vehicleUploads,
	orders,
	leads,
	inspectionOrders,
	calender,
	tags,
	userLevels,
	signupStats,
});
